/* eslint-disable import/prefer-default-export */
import urlTool from '@/utils/urlTool';

export function getInstallCallBackByUrlParams() {
    const suiteId = urlTool.getUrlParameter('suite_id');
    const isInstallCallBack = urlTool.getUrlParameter('wwappinstall') === '1';

    return {
        suiteId,
        isInstallCallBack
    };
}
